import { useState, useEffect } from 'react'

// Reads /api/overnight-split — a ticker's return split into the part earned
// while the market was closed (prev close → open) and the part earned during
// the regular session (open → close), per timeframe.
//
// "Overnight" bundles after-hours and pre-market into one number: price_history
// stores daily bars, so the path between yesterday's close and today's open
// isn't recorded. Separating the two needs intraday bars per day per ticker.
//
// Returns { windows, asOf, loading }. windows is keyed by timeframe and each
// entry is either null (not enough history) or:
//   { overnight, session, total, days }   // percentages, already ×100
export function useOvernightSplit(ticker) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!ticker) { setData(null); setLoading(false); return }
    let cancelled = false
    setLoading(true)
    fetch(`/api/overnight-split?ticker=${encodeURIComponent(ticker)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled) { setData(d); setLoading(false) } })
      .catch(() => { if (!cancelled) { setData(null); setLoading(false) } })
    return () => { cancelled = true }
  }, [ticker])

  return {
    windows: data?.windows ?? {},
    asOf: data?.asOf ?? null,
    loading,
  }
}
